import React, { FC } from 'react';
import { classNames } from '../../../utils';
import { CustomClassContainerProps, CustomClassContainer } from '../../utility';
import { CharLimitsProps } from '../types';

interface TextInputProps extends CustomClassContainerProps {
  label?: string;
  name: string;
  placeholder?: string;
  tabIndex?: number;
  autoComplete?: string;
  type?: string;
  value?: string;
  charLimits?: CharLimitsProps;
  readOnly?: boolean;
  icon?: React.ReactNode;
  validation?: (input: string) => boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e?: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e?: React.FocusEvent<HTMLInputElement>) => void;
}

const TextInput: FC<TextInputProps> = (props) => {
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.charLimits && e.target.value.length > props.charLimits.max)
      return;

    if (props.validation && !props.validation(e.target.value)) return;

    props.onChange(e);
  };

  return (
    <CustomClassContainer classes={props.classes}>
      <div className='relative flex w-auto flex-col'>
        {props.label && (
          <div className='mb-2 flex flex-row items-center justify-between'>
            <label
              className='text-base font-medium tracking-tight text-gray-dark'
              htmlFor={props.name}
            >
              {props.label}
            </label>
            {props.children ? <div>{props.children}</div> : null}
          </div>
        )}
        <input
          className={classNames(
            'appearance-none rounded-lg border border-gray-light py-4 text-base font-medium placeholder-gray-light shadow-sm outline-none focus:outline-none',
            props.icon ? 'pl-16 pr-5' : 'px-5',
            props.readOnly
              ? 'select-none text-gray focus:border-transparent focus:outline-none focus:ring-2 focus:ring-gray-light'
              : 'text-gray-darkest focus:border-transparent focus:outline-none focus:ring-2',
            !props.readOnly &&
              props.charLimits &&
              props.charLimits.min &&
              (props.value ? props.value.length : 0) < props.charLimits.min
              ? 'focus:ring-red'
              : 'focus:ring-green',
          )}
          id={props.name}
          tabIndex={props.tabIndex}
          autoComplete={props.autoComplete}
          name={props.name}
          value={props.value}
          type={props.type ? props.type : 'text'}
          placeholder={props.placeholder ? props.placeholder : ''}
          onChange={handleOnChange}
          readOnly={props.readOnly}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
        />
        {props.icon && (
          <div className='absolute left-0 top-1/2 ml-5 -translate-y-1/2 transform'>
            {props.icon}
          </div>
        )}
        {props.charLimits ? (
          <p className='mt-1 self-end px-1 text-xxs font-medium text-gray-light'>
            {props.value ? props.value.length : 0} / {props.charLimits.max}
          </p>
        ) : null}
      </div>
    </CustomClassContainer>
  );
};

export default TextInput;
